import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, Whisper } from 'rsuite';
import React from 'react';

const RsTooltip = (props) => {
  const tooltip = <Tooltip>{props.children}</Tooltip>;
  return (
    <Whisper
      placement={props.placement || 'bottom'}
      controlId='control-id-hover'
      trigger='hover'
      speaker={tooltip}
    >
      <div className='flex size-fit cursor-pointer items-center'>
        <FontAwesomeIcon icon={faQuestionCircle} className='text-[#A4A7AE]' />
      </div>
    </Whisper>
  );
};

export default RsTooltip;
